module.exports = __webpack_public_path__ + "static/karaoke-14d23e0c766816a77e4671fcb55d1556.jpg";